import { useEffect } from "react";
import { useLocation } from "react-router";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import AlertMessage from "../shared/AlertMessage/AlertMessage";
import Loading from "../shared/Loading";
import Navbar from "../SidebarNav/Navbar";
import { handleAuthentication } from "./HandleAuthentication";
import ThemeProvider from "../Theme/ThemeProvider";

/**
 * This component handles the authentication process by extracting query parameters,
 * validating tokens, and dispatching actions accordingly. It displays loading state
 * and error messages during the process and only shows the sidebar if the user
 * is successfully authenticated and there are no user-related errors
 */
const LoginHandler = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  const user = useAppSelector((state) => state.user);
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const authenticate = async () => {
      if (!auth.error && !auth.authType.isAuthenticated) {
        await handleAuthentication({ queryParams: queryParams, auth, dispatch });
      }
    };
    authenticate();
  }, [location.search, auth.authType.isAuthenticated]); // Re-run the effect when location.search or auth.authType.isAuthenticated changes

  return (
    <>
      <ThemeProvider>
        {auth.error?.title && <AlertMessage message={{ type: "danger", text: auth.error }} />}
        {user.error?.title && <AlertMessage message={{ type: "danger", text: user.error }} />}
        {auth.loading ? <Loading /> : null}
        {!user.error && auth.authType.isAuthenticated ? <Navbar /> : null}
      </ThemeProvider>
    </>
  );
};

export default LoginHandler;
